export default __webpack_public_path__ + "static/media/undelegate.f0fcdffe.svg";